import slugs from "navigation/slugs";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "utils/number/number";
import { ComingSoon, Loading } from "components/commons";
import { ReactComponent as Tiktok } from "assets/icons/tiktok.svg";
import { ReactComponent as Checklist } from "assets/icons/checklist.svg";

import {
  BellIcon,
  BellSnoozeIcon,
  ArrowPathIcon,
} from "@heroicons/react/24/outline";
import { ReactComponent as TiktokSocial } from "assets/images/tiktokSocial.svg";

import {
  getTiktokFollowingUser,
  subscribe,
  unsubscribe,
} from "services/apis/apis";
import { useCallback, useEffect, useState } from "react";
import { ACCESS_TOKEN, getItem } from "local-storage";

export const Following = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isRestricted, setIsRestricted] = useState(false);

  const [datas, setDatas] = useState<any[]>([]);
  const accessToken = getItem(ACCESS_TOKEN) || "";

  const navigate = useNavigate();

  const handleUnsubscribe = async (userId: string, index: number) => {
    try {
      if (!accessToken) return;

      const updatedDatas = [...datas];
      updatedDatas[index].isSubscribe = false;
      updatedDatas[index].numFan = updatedDatas[index].numFan - 1;
      setDatas(updatedDatas);

      const result = await unsubscribe(accessToken, userId);

      if (!result) {
        setDatas(datas);
      }

      console.log(result);
    } catch (error) {
      console.log(
        "🚀 ~ file: OtherProfile.tsx:43 ~ handleUnsubscribe ~ error:",
        error
      );
    }
  };

  const handleSubscribe = async (userId: string, index: number) => {
    try {
      if (!accessToken) return;

      const updatedDatas = [...datas];
      updatedDatas[index].isSubscribe = true;
      updatedDatas[index].numFan = updatedDatas[index].numFan + 1;
      setDatas(updatedDatas);

      const result = await subscribe(accessToken, userId);

      if (!result) {
        setDatas(datas);
      }
      console.log(
        "🚀 ~ file: OtherProfile.tsx:218 ~ handleSubscribe ~ result:",
        result
      );
    } catch (error) {
      console.log(
        "🚀 ~ file: OtherProfile.tsx:219 ~ handleSubscribe ~ error:",
        error
      );
    }
  };
  const getFollowingTiktok = useCallback(
    async (forceUpdate?: boolean) => {
      try {
        if (!accessToken) {
          return setIsLoading(false);
        }
        setIsLoading(true);

        const res = await getTiktokFollowingUser(
          accessToken,
          200,
          0,
          forceUpdate
        );
        setDatas(res?.followings);
        setIsLoading(false);
      } catch (error: any) {
        if (error?.response?.status === 500) {
          setIsRestricted(true);
        }

        setIsLoading(false);
      }
    },
    [accessToken]
  );

  useEffect(() => {
    getFollowingTiktok();
  }, [getFollowingTiktok]);

  const renderBottomCard = (item: any) => {
    return (
      <>
        {item?.total_holders && item?.total_shares && item?.current_price ? (
          <div className="flex justify-between text-xs font-medium p-4 border-t border-gray-800">
            <div className="flex items-center">
              <div className="flex items-baseline gap-2">
                <span className="uppercase text-slate-500">Holder:</span>
                <span className="text-info font-mono whitespace-nowrap">
                  {item?.total_holders || "-"}
                </span>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="flex items-baseline gap-2">
                <span className="uppercase text-slate-500">Shares:</span>
                <span className="text-primary font-mono whitespace-nowrap">
                  {item?.total_shares || "-"}
                </span>
              </div>

              <div className="flex items-baseline gap-2">
                <span className="uppercase text-slate-500">Price:</span>
                <span className="text-secondary font-mono whitespace-nowrap">
                  {Number(item?.current_price)
                    ? Number(item?.current_price) < 0.0001
                      ? "<0.0001"
                      : "~" + item?.current_price.toFixed(4) + " Ξ"
                    : "-"}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-xs font-medium p-4 border-t border-gray-800">
            <div className="flex items-baseline gap-2">
              <span className="uppercase text-slate-500">Subscribers:</span>
              <span className="text-info font-mono whitespace-nowrap">
                {item?.numFan || "-"}
              </span>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <div className="my-4 text-xl flex justify-between items-center mt-14">
        <div>
          <Tiktok className="w-5 h-5 inline mb-1" /> Your Following on Tiktok
        </div>
        <ArrowPathIcon
          className="w-6 h-6 p-1"
          onClick={() => getFollowingTiktok(true)}
        />{" "}
      </div>
      {isLoading ? <Loading /> : null}
      {!isLoading && isRestricted ? (
        <div className="flex flex-col gap-6">
          <TiktokSocial className="w-24" />

          <div className="flex flex-col gap-4 text-sm text-slate-300">
            <div className=" text-xl ">
              <Tiktok className="w-5 h-5 inline mb-1" /> Your Following List is
              Restricted
            </div>{" "}
            <p className="">
              Follow the guide below to enable to fetch your Tiktok following
              list on fan.tech:
            </p>
            <div className="flex flex-col gap-2">
              <div className="flex gap-2 items-center font-normal">
                <div className="w-5 h-5 rounded-full flex justify-center items-center bg-[#279EFF] font-medium text-xs">
                  1
                </div>
                Visit Tiktok “Settings and Privacy”
              </div>
              <div className="flex gap-2 items-center font-normal">
                <div className="w-5 h-5 rounded-full flex justify-center items-center bg-[#279EFF] font-medium text-xs">
                  2
                </div>
                <span>Click on “Privacy”</span>
              </div>
              <div className="flex gap-2 items-center font-normal">
                <div className="w-5 h-5 rounded-full flex justify-center items-center bg-[#279EFF] font-medium text-xs">
                  3
                </div>
                Set up your “Following list” to “Everyone”
              </div>
            </div>
          </div>
        </div>
      ) : !datas?.length && !isLoading ? (
        <div className="flex-1 flex flex-col justify-center items-center">
          <ComingSoon
            type="eyes"
            title="You are not following anyone!"
            des="Your following on TikTok will be listed here."
          />
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-4 w-full">
            {datas?.map((item: any, idx: number) => {
              return (
                <div
                  className="border-2 rounded-xl border-gray-800"
                  key={idx}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`${slugs.profile}/${item?.id}`);
                  }}
                >
                  <div
                    className={`flex p-4 gap-4 justify-between items-center `}
                  >
                    <div className="flex items-center  gap-3 w-full">
                      <div className="shadow-sm overflow-hidden flex justify-center items-center relative">
                        {item?.metadata?.avatar_168x168 ? (
                          <img
                            className="h-12 w-12 shadow-sm rounded-full object-fill"
                            src={item?.metadata?.avatar_168x168}
                            alt="avatar"
                          />
                        ) : (
                          <i className="fa-duotone fa-user text-2xl text-primary"></i>
                        )}
                        {item?.user_id ? (
                          <Checklist className="w-4 h-4 absolute bottom-0 right-0" />
                        ) : null}
                      </div>

                      <div className="flex-1 flex justify-between">
                        <h6
                          className="flex flex-col items-baseline transition-all"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`${slugs.profile}/${item?.id}`);
                          }}
                        >
                          <span
                            className={`text-base font-normal leading-none mr-1 mb-1`}
                          >
                            {item?.nickname}
                          </span>
                          <span className="text-xs font-normal text-slate-500">
                            {item?.follower_count
                              ? formatNumber(Number(item.follower_count))
                              : "-"}{" "}
                            Followers
                          </span>
                        </h6>
                        {item?.isSubscribe ? (
                          <BellIcon
                            className="w-6 h-6  text-[#1BC57E]"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleUnsubscribe(item.id, idx);
                            }}
                          />
                        ) : (
                          <BellSnoozeIcon
                            className="w-6 h-6"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSubscribe(item.id, idx);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {renderBottomCard(item)}
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};
